function error(state, action) {
  switch (action.type) {
    case 'FETCH_ERROR' :
      return { ...state, fetch: action.error };
    case 'SAVE_ERROR' :
      return { ...state, save: action.error };
    case 'TEXT_ANSWER_ERROR' :
      return { ...state, textAnswer: action.error };
    default:
      return null;
  }
}

export default error;
